"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var FormWrapper = /** @class */ (function (_super) {
    __extends(FormWrapper, _super);
    function FormWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormWrapper.prototype.findHeader = function () {
        return this.find('[awsui-form-region="header"]');
    };
    FormWrapper.prototype.findDescription = function () {
        return this.find('[awsui-form-region="description"]');
    };
    FormWrapper.prototype.findContent = function () {
        return this.find('[awsui-form-region="content"]');
    };
    FormWrapper.prototype.findError = function () {
        return this.find('[awsui-form-region="errorText"]');
    };
    FormWrapper.prototype.findActions = function () {
        return this.find('[awsui-form-region="actions"]');
    };
    return FormWrapper;
}(dom_1.ComponentWrapper));
exports.default = FormWrapper;
//# sourceMappingURL=awsui-form.js.map